module.exports = __webpack_public_path__ + "static/media/RICE_1x.97ef88b5.png";